import { FormInstance } from 'antd'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { NamePath } from 'antd/es/form/interface'
import { useWatch as useWatchAntd } from 'antd/es/form/Form'

export default function getUseWatch<FV, FI extends FormInstance>() {
  type ReturnPromise<T> = T extends Promise<infer ValueType> ? ValueType : never

  type GetGeneric<TForm extends FormInstance> = ReturnPromise<ReturnType<TForm['validateFields']>>

  function useWatch<TDependencies extends keyof GetGeneric<FI>>(
    dependencies: TDependencies | [TDependencies]
  ): GetGeneric<FI>[TDependencies]

  function useWatch<
    TDependencies1 extends keyof GetGeneric<FI>,
    TDependencies2 extends keyof GetGeneric<FI>[TDependencies1],
  >(dependencies: [TDependencies1, TDependencies2]): GetGeneric<FI>[TDependencies1][TDependencies2]

  function useWatch<
    TDependencies1 extends keyof GetGeneric<FI>,
    TDependencies2 extends keyof GetGeneric<FI>[TDependencies1],
    TDependencies3 extends keyof GetGeneric<FI>[TDependencies1][TDependencies2],
  >(
    dependencies: [TDependencies1, TDependencies2, TDependencies3]
  ): GetGeneric<FI>[TDependencies1][TDependencies2][TDependencies3]

  function useWatch(dependencies: NamePath) {
    const form = useFormInstance<FV>()
    return useWatchAntd(dependencies) || form.getFieldValue(dependencies)
  }

  return useWatch
}
